import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ConsultaTramitesComponent} from "../../consulta-tramites/consulta-tramites.component";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {ResultadosBusquedaComponent} from "../../resultados-busqueda/resultados-busqueda.component";
import {AsidePublicComponent} from "../../aside-public/aside-public.component";
import {MultiSelectModule} from "primeng/multiselect";
import {VwSecDependencia} from "../../../../shared/interfaces/seguridad";
import {FormsModule} from "@angular/forms";
import {ButtonDirective} from "primeng/button";
import {InputTextModule} from "primeng/inputtext";
import {NgOptimizedImage} from "@angular/common";
import {MessageService} from "primeng/api";
import {ActivatedRoute, Router} from "@angular/router";
import {SecDependenciaService} from "../../../../services/sec-dependencia.service";
import {firstValueFrom, forkJoin, Subscription} from "rxjs";
import {DataViewModule} from "primeng/dataview";
import {ItemTramiteResultadoComponent} from "../../item-tramite-resultado/item-tramite-resultado.component";

@Component({
  selector: 'app-sede-electronica-tramites',
  standalone: true,
  imports: [
    TranslatePipe,
    ResultadosBusquedaComponent,
    AsidePublicComponent,
    MultiSelectModule,
    FormsModule,
    ButtonDirective,
    InputTextModule,
    NgOptimizedImage,
    DataViewModule,
  ],
  templateUrl: './sede-electronica-tramites.component.html',
  styleUrl: './sede-electronica-tramites.component.scss'
})
export class SedeElectronicaTramitesComponent implements OnInit, OnDestroy {

    dependencies: VwSecDependencia[] = [];
    dependenciesSelected: VwSecDependencia[] = [];
    tramiteSearch: string | undefined = undefined;
    radicado: string = '';
    translations: any = {};
    subscriptionRoute: Subscription | undefined = undefined;


  @ViewChild(ResultadosBusquedaComponent) resultadosBusquedaComponent!: ResultadosBusquedaComponent;


  constructor(private readonly _ms: MessageService,
              private readonly router: Router,
              private readonly _ds: SecDependenciaService,
              private readonly activatedRoute: ActivatedRoute,
              private readonly _translate: TranslateService) {
  }

  ngOnInit() {
    this.translate().then();
    this.getDependencies();
    this.getParams();
  }

    ngOnDestroy(): void {
        this.subscriptionRoute?.unsubscribe();
    }



  private async translate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      completeCampos: this._translate.get('form.msg.complete-campos'),
      warnSummary: this._translate.get('form.msg.warn-summary'),
    }));
  }

  private getParams = () => {
   this.subscriptionRoute =  this.activatedRoute.params.subscribe(param => {
      if (param['text'] && param['text'].trim().length > 0) {
        this.tramiteSearch = param['text'];
        this.search();
      }
    })
  }

  search = () => {
    if (!this.tramiteSearch) {
      this._ms.add({
        severity: 'warn',
        summary: this.translations.warnSummary,
        detail: this.translations.completeCampos
      });
      return;
    }
    if (!this.resultadosBusquedaComponent)
        return;
    this.resultadosBusquedaComponent.text = this.tramiteSearch;
    this.resultadosBusquedaComponent.dependencia = this.dependenciesSelected;
    this.resultadosBusquedaComponent.getTramitesBusqueda(this.tramiteSearch,
      this.dependenciesSelected?.map(f => f.id));
  }

  searchRadicado = () => {
    if (!this.radicado) {
      this._ms.add({
        severity: 'warn',
        summary: this.translations.warnSummary,
        detail: this.translations.completeCampos
      });
      return;}

      this.router.navigateByUrl(`sede-electronica/estado-tramite/${this.radicado}`).then();
  }

  getDependencies = () => {
    this._ds.getAllActivos().subscribe({
      next: value => this.dependencies = value
    })
  }

}
